import $ from "jquery";


let auth = {};
auth.login = function login(host, code, cb) {
  auth.url = host;
  $.ajax({
    method: 'POST',
    url: host + '/api/login/guest',
    data: JSON.stringify({ code: code }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json'
  })
    .done(function success(data) {
      cb(false, data);
    })
    .fail(function ferror(err) {
      console.log(err)
      if (err.responseJSON) {
        var error = err.responseJSON;

        if (error.blockedUntil) {
          var b = error.blockedUntil;
          cb('Too many wrong attempts. Wait for ' + b.value + ' ' + b.unit + ' and try again.');
          return;
        }

        if (error.error) {
          cb(error.error);
          return;
        }
      }

      cb('Could not authenticate.');
    });
};

auth.disconnect = function disconnect() {
  skt.token = null;
  ui.toggleDisconnected();
};

export default auth;
